import { Select, Table, Tabs } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useGetSheetObjectMutation } from "src/app/services/sheets";
import { useTypedSelector } from "src/app/store";
import { IObjectResponse } from "src/app/services/sheets/type";
import ContentTop from "src/layout/content/ContentTop";
import {
  objectColumns,
  MONTH_KEYS,
  getMonthLabel,
  flattenObjectData,
  IFlatRow,
} from "./constants";
import { useTranslation } from "react-i18next";
import "../analyses.scss";

function ObjectPage() {
  const { t } = useTranslation();
  const [getSheetObject, { isLoading }] = useGetSheetObjectMutation();
  const [data, setData] = useState<IObjectResponse>();
  const [selectedMonth, setSelectedMonth] = useState<string>("january");
  const { screenMode } = useTypedSelector((state) => state.layout);
  const [tableHeight, setTableHeight] = useState<number>();

  useEffect(() => {
    setTimeout(() => {
      setTableHeight(window.innerHeight - 220);
    }, 300);
  }, [screenMode]);

  useEffect(() => {
    getSheetObject()
      .unwrap()
      .then((res) => setData(res));
  }, []);

  const monthOptions = useMemo(() => {
    return MONTH_KEYS.map((key) => ({
      value: key,
      label: getMonthLabel(key, t),
    }));
  }, [t]);

  const currentMonth = data?.[selectedMonth];

  const stationData = useMemo(
    () => flattenObjectData(currentMonth?.station, t),
    [currentMonth, t]
  );

  const basketData = useMemo(
    () => flattenObjectData(currentMonth?.basket, t),
    [currentMonth, t]
  );

  const rowClassName = (record: IFlatRow) => {
    const classes: string[] = [];
    if (record.rowType === "difference") classes.push("difference-row");
    if (record.isTotal) classes.push("total-object-row");
    return classes.join(" ");
  };

  const tabItems = [
    {
      key: "station",
      label: t("sidebar.analyses.station"),
      children: (
        <Table
          columns={objectColumns(t)}
          dataSource={stationData}
          scroll={{ x: 2200, y: tableHeight }}
          bordered
          pagination={false}
          loading={isLoading}
          size="small"
          rowClassName={rowClassName}
        />
      ),
    },
    {
      key: "basket",
      label: t("sidebar.analyses.basket"),
      children: (
        <Table
          columns={objectColumns(t)}
          dataSource={basketData}
          scroll={{ x: 2200, y: tableHeight }}
          bordered
          pagination={false}
          loading={isLoading}
          size="small"
          rowClassName={rowClassName}
        />
      ),
    },
  ];

  return (
    <div className="analyses-page">
      <ContentTop title={t("sidebar.analyses.object")}>
        <div className="analyses-filters">
          <Select
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={monthOptions}
            style={{ width: 200 }}
          />
        </div>
      </ContentTop>

      <Tabs items={tabItems} />
    </div>
  );
}

export default ObjectPage;
